import initSourcegraph from './index';

initSourcegraph();
